// extracted by mini-css-extract-plugin
export default {"bg-overlay":"Tr4n3d","bgOverlay":"Tr4n3d","bg-img-overlay":"wRqk6s","bgImgOverlay":"wRqk6s"};